
import { DataPointsApiResponse, DataTable } from '@tableau/metrics-engine';

import { IMetricUsageInfo } from '../../spacesPlatform/models/IUsageInfo';
import { ICreatedItemInfo, IDescriptionItemInfo, IExplorableItemTypeInfo, IFavoriteItem, IIdItemInfo, ILocationItemInfo,ILuidItemInfo, INamedItemInfo, IOwnedItemInfo, IProjectItemInfo, ISuspendedItem, ITaggedItemInfo, IUpdatedItemInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { ConnectedViewContextType } from '../serverApi/types/IMetric';
import { IMetricDataPointsSchema } from '../serverApi/types/IMetricDataList';

export interface IMetricInfo extends
    IExplorableItemTypeInfo<'metric'>,
    INamedItemInfo,
    IIdItemInfo,
    IUpdatedItemInfo,
    ICreatedItemInfo,
    IFavoriteItem,
    IDescriptionItemInfo,
    ITaggedItemInfo,
    IProjectItemInfo,
    ILocationItemInfo,
    IMetricDataInfo,
    IOwnedItemInfo,
    Partial<ISuspendedItem>,
    ILuidItemInfo,
    IUsageMetricInfo
{
  connectedView: IConnectedViewInfo;
  usageInfo?: IMetricUsageInfo;
  usageInfoMaxValues?: IMetricUsageInfo;
}

export type IMetricInfoWithoutData = Omit<IMetricInfo, keyof IMetricDataInfo>;

export interface IMetricDataInfo {
  dataPoints?: DataTable;
  schema?: IMetricDataPointsSchema;
  dataRefreshedTimestamp?: string;
}

export interface IConnectedViewInfo extends INamedItemInfo {
  viewId: string;
  isViewModified: boolean;
  path: string;
  thumbnailUrl: string;
  type: ConnectedViewContextType;
}

export function isMetricInfo(metric: IExplorableItemTypeInfo): metric is IMetricInfo {
  return (metric.contentType === 'metric');
}

export interface IUsageMetricInfo {
  dataPointsApiResponse?: DataPointsApiResponse;
  isUsageMetric?: boolean;
  workbookId?: string;
}

export function isUsageMetricInfo(metric: any): metric is IUsageMetricInfo {
  return metric.isUsageMetric === true && metric.dataPointsApiResponse !== undefined && metric.workbookId !== undefined;
}